import React, { useState } from "react";
import { MessageCircle, X, Phone } from "lucide-react";
import { site } from "../mock/mock";
import { logContactEvent } from "../lib/api";

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const msg = encodeURIComponent(
    "Hello! I would like to know more about admissions at The KPR Academy."
  );

  return (
    <div className="fixed bottom-6 right-5 z-[70] flex flex-col items-end gap-3 sm:bottom-8 sm:right-7">
      {open && (
        <div
          className="fade-up w-[300px] overflow-hidden rounded-2xl"
          style={{ background: "var(--cream)", boxShadow: "0 30px 60px -30px rgba(8,46,41,.6)" }}
        >
          <div className="px-5 py-4" style={{ background: "var(--teal-800)" }}>
            <p className="text-[0.7rem] uppercase tracking-[0.16em]" style={{ color: "var(--gold-200)" }}>
              Admissions desk
            </p>
            <p className="font-display mt-1 text-[1.05rem]" style={{ color: "#FBF7F0" }}>
              How can we help?
            </p>
          </div>
          <div className="p-4">
            {site.whatsapps.map((w) => (
              <a
                key={w.number}
                href={`https://wa.me/${w.number}?text=${msg}`}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  logContactEvent({
                    channel: "whatsapp",
                    number: w.number,
                    display: w.display,
                    message: decodeURIComponent(msg),
                    label: "floating widget",
                  })
                }
                className="mb-2 flex items-center justify-between gap-3 rounded-xl px-4 py-3"
                style={{ background: "#1FA855", color: "#fff" }}
              >
                <span className="flex items-center gap-2.5">
                  <MessageCircle size={16} />
                  <span className="text-[0.82rem] font-semibold">WhatsApp</span>
                </span>
                <span className="text-[0.78rem]">{w.display}</span>
              </a>
            ))}

            <div className="hairline-gold my-3" />
            <p className="px-1 text-[0.7rem] uppercase tracking-[0.14em]" style={{ color: "var(--gold)" }}>
              Or call the hotline
            </p>
            {site.hotlines.map((h) => (
              <a
                key={h}
                href={`tel:${h.replace(/\s/g, "")}`}
                onClick={() =>
                  logContactEvent({
                    channel: "call",
                    number: h.replace(/\s/g, ""),
                    display: h,
                    label: "floating widget",
                  })
                }
                className="mt-2 flex items-center gap-3 rounded-xl px-4 py-2.5"
                style={{ border: "1px solid rgba(11,59,54,.14)", color: "var(--teal-800)" }}
              >
                <Phone size={15} />
                <span className="text-[0.84rem] font-semibold">{h}</span>
              </a>
            ))}
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Contact us on WhatsApp"
        className="grid h-14 w-14 place-items-center rounded-full"
        style={{
          background: open ? "var(--teal-800)" : "#1FA855",
          color: "#fff",
          boxShadow: "0 16px 34px -14px rgba(31,168,85,.75)",
          transition: "transform .3s ease, background .3s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.06)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "none")}
      >
        {open ? <X size={22} /> : <MessageCircle size={24} />}
      </button>
    </div>
  );
}
